module.exports = __webpack_public_path__ + "img/quality@2x.1a8da09.jpg";